import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import history from 'app/routes/history';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  refundSchema,
  refundListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/refunds/actions';
import { getMatchPayment } from 'app/ducks/matchPayments/actions';
import { RefundsActionTypes as types } from 'app/ducks/refunds/types';

function* createRefundSaga(action): any {
  yield put(sagaActions.createRefundPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationRefunds.create(action.payload.data);

  if (response) {
    const normalizedResponse = normalize(response, refundSchema);

    yield put(sagaActions.createRefundSuccess(normalizedResponse));
    if (!_.isEmpty(action.payload?.matchPayment?.id)) {
      yield put(yield getMatchPayment(action.payload.matchPayment.id));
    }

    if (action.payload.callbackFunction !== undefined) {
      action.payload.callbackFunction(
        undefined,
        normalizedResponse.entities?.refunds[
          normalizedResponse.result
        ],
      );
    }
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createRefundFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateRefundSaga(action): any {
  yield put(sagaActions.updateRefundPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).refunds.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, refundSchema);

    yield put(sagaActions.updateRefundSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateRefundFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getRefundSaga(action): any {
  yield put(sagaActions.getRefundPending());

  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationRefunds.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, refundSchema);
    yield put(sagaActions.getRefundSuccess(normalizedResponse));
    return normalizedResponse.entities.refunds[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getRefundFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllRefundsSaga(action): any {
  yield put(
    sagaActions.getAllRefundsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());
  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.refunds.pagination),
    )
    : action.payload.pagination;
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationRefunds.list(paginationObject);

  if (response) {
    const normalizedResponse = normalize(
      response,
      refundListSchema,
    );

    yield put(
      sagaActions.getAllRefundsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllRefundsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createRefundSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_REFUND_REQUESTED,
    createRefundSaga,
  );
}

function* updateRefundSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_REFUND_REQUESTED,
    updateRefundSaga,
  );
}

function* getRefundSagaWatcher(): any {
  yield takeLatest(
    types.GET_REFUND_REQUESTED,
    getRefundSaga,
  );
}

function* getAllRefundsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_REFUNDS_REQUESTED,
    getAllRefundsSaga,
  );
}

export default function* root(): any {
  yield all([
    createRefundSagaWatcher(),
    updateRefundSagaWatcher(),
    getRefundSagaWatcher(),
    getAllRefundsSagaWatcher(),
  ]);
}
